import {theme} from "./Tema";

export const VALORENVIOGRATIS = 350000

export const ESTADOSPRODUCTO = [
    {
        nombre: 'In Stock',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Agotado',
        color: theme.palette.secondary.main
    },
]


export const ESTADOSMAYORISTAS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Seguimiento',
        color: '#232323'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]


export const ESTADOSPEDIDOS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Preparando',
        color: '#232323'
    },
    {
        nombre: 'Despachado',
        color: '#5c5c5c'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]

export const LOCALES = [
    {
        nombre: 'Puenes',
        color: '#FFB100'
    },
    {
        nombre: 'Parque 20 de Julio',
        color: '#E30033'
    },
    {
        nombre: 'Carrera 11',
        color: '#5c5c5c'
    }
]







export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]
